import { create } from 'zustand';
import { PRD4011_R01WorkplaceDto, PRD4011_R01PlcStatusDto } from './Dto_PRD4011_R01';

export interface PRD4011_R01Filter {
    compCd: string;
    searchDate: Date | undefined;
    autoRefreshInterval: number | null;
}

export const defaultPRD4011_R01Filter: PRD4011_R01Filter = {
    compCd: '',
    searchDate: new Date(),
    /** 제조현장 모니터링: 기본 자동조회 주기(분) */
    autoRefreshInterval: 5,
};

export interface Store_PRD4011_R01 {
    PRD4011_R01Filter: PRD4011_R01Filter;
    setPRD4011_R01Filter: (filter: Partial<PRD4011_R01Filter>) => void;

    /** 라인 카드 목록 */
    PRD4011_R01List: PRD4011_R01WorkplaceDto[];
    setPRD4011_R01List: (list: PRD4011_R01WorkplaceDto[]) => void;

    /** PLC 상태 목록 */
    PRD4011_R01PlcStatusList: PRD4011_R01PlcStatusDto[];
    setPRD4011_R01PlcStatusList: (list: PRD4011_R01PlcStatusDto[]) => void;

    /** 최종 수집 시각 / 1시간 이상 지연 여부 */
    PRD4011_R01LastDataTime: string | null;
    setPRD4011_R01LastDataTime: (value: string | null) => void;
    isPRD4011_R01Delayed: boolean;
    setIsPRD4011_R01Delayed: (value: boolean) => void;

    /** 확인 대기 중인 에러 알림 (확인 버튼을 누를 때까지 유지) */
    PRD4011_R01AlarmList: PRD4011_R01PlcStatusDto[];
    setPRD4011_R01AlarmList: (list: PRD4011_R01PlcStatusDto[]) => void;

    initData: () => void;
}

export const usePRD4011_R01Store = create<Store_PRD4011_R01>((set) => ({
    PRD4011_R01Filter: defaultPRD4011_R01Filter,
    setPRD4011_R01Filter: (filter) =>
        set((state) => ({
            PRD4011_R01Filter: { ...state.PRD4011_R01Filter, ...filter },
        })),

    PRD4011_R01List: [],
    setPRD4011_R01List: (list) => set({ PRD4011_R01List: list }),

    PRD4011_R01PlcStatusList: [],
    setPRD4011_R01PlcStatusList: (list) => set({ PRD4011_R01PlcStatusList: list }),

    PRD4011_R01LastDataTime: null,
    setPRD4011_R01LastDataTime: (value) => set({ PRD4011_R01LastDataTime: value }),
    isPRD4011_R01Delayed: false,
    setIsPRD4011_R01Delayed: (value) => set({ isPRD4011_R01Delayed: value }),

    PRD4011_R01AlarmList: [],
    setPRD4011_R01AlarmList: (list) => set({ PRD4011_R01AlarmList: list }),

    initData: () =>
        set({
            PRD4011_R01Filter: defaultPRD4011_R01Filter,
            PRD4011_R01List: [],
            PRD4011_R01PlcStatusList: [],
            PRD4011_R01LastDataTime: null,
            isPRD4011_R01Delayed: false,
            PRD4011_R01AlarmList: [],
        }),
}));
